import { render } from "./ui-sortable.vue?vue&type=template&id=4d1f46f2"
import script from "./ui-sortable.vue?vue&type=script&lang=js"
export * from "./ui-sortable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__